import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';
import Page from 'components/pages/Base/Page/Page';

const StyledTeamsSettingPage = styled(Page)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--teams-setting-page-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--teams-setting-page-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  min-width: calc(100vw - (${props => props.$css.$var('--teams-setting-page-bounds-left')} + ${props => props.$css.$var('--teams-setting-page-bounds-right')}));
  
  .TeamsSettingPage {
    &-teams {
      padding: 0 ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)};
      &-team {
        aspect-ratio: 536/362;
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .TeamsSettingPage {
      &-teams {
        padding: 0 ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledTeamsSettingPage.propTypes = {
  theme: PropTypes.object
};

export default StyledTeamsSettingPage;
